import { API_FILE } from 'Constants/client-modules';
import { FILE_API_URL } from 'Constants/apis';

import * as ACTION_TYPES from './types';

export function fileUpload(body) {
  return {
    types: [
      ACTION_TYPES.FILE_UPLOAD_REQUESTED,
      ACTION_TYPES.FILE_UPLOAD_SUCCEED,
      ACTION_TYPES.FILE_UPLOAD_FAILED,
    ],
    promise: client => client.post('/files', body),
    options: {
      clientName: API_FILE,
    },
  };
}

export function getFile(fileId) {
  return {
    types: [
      ACTION_TYPES.FILE_GOT_REQUESTED,
      ACTION_TYPES.FILE_GOT_SUCCEED,
      ACTION_TYPES.FILE_GOT_FAILED,
    ],
    promise: client => client.get(`/files/${fileId}/info`),
    options: {
      clientName: API_FILE,
    },
  };
}

export function uploadFileToSend(body) {
  return {
    types: [
      ACTION_TYPES.FILE_UPLOAD_TO_SEND_REQUESTED,
      ACTION_TYPES.FILE_UPLOAD_TO_SEND_SUCCEED,
      ACTION_TYPES.FILE_UPLOAD_TO_SEND_FAILED,
    ],
    promise: client => client.post('/files', body),
    options: {
      clientName: API_FILE,
    },
  };
}

export function fileUploadURL(body) {
  return {
    types: [
      ACTION_TYPES.FILE_UPLOAD_URL_REQUESTED,
      ACTION_TYPES.FILE_UPLOAD_URL_SUCCEED,
      ACTION_TYPES.FILE_UPLOAD_URL_FAILED,
    ],
    promise: client => client.post('/files', body),
    options: {
      clientName: API_FILE,
    },
  };
}

export function fileUpdate(id, body) {
  return {
    types: [
      ACTION_TYPES.FILE_UPDATE_REQUESTED,
      ACTION_TYPES.FILE_UPDATE_SUCCEED,
      ACTION_TYPES.FILE_UPDATE_FAILED,
    ],
    promise: client => client.put(`/files/${id}/info`, body),
    options: {
      clientName: API_FILE,
      headers: {
        'Content-Type': 'application/json',
      },
      apiUrl: FILE_API_URL,
    },
  };
}

export function healthSummaryFileUpload(payload) {
  return {
    type: ACTION_TYPES.HEALTH_SUMMARY_FILE_UPLOAD_REQUESTED,
    payload,
  };
}
